import type { View } from "../../../../common/types.ts";

type DailyScheduleGame = View<"dailySchedule">["upcoming"][number];

export const isDailyScheduleUserGame = (game: DailyScheduleGame, userTid: number) =>
  game.teams.some((team) => team.tid === userTid);

export const sortDailyScheduleUpcomingGames = (games: DailyScheduleGame[], userTid: number) =>
  games
    .map((game, index) => ({
      game,
      index,
      userTeamGame: isDailyScheduleUserGame(game, userTid),
    }))
    .sort((a, b) => {
      if (a.userTeamGame !== b.userTeamGame) {
        return a.userTeamGame ? -1 : 1;
      }

      return a.index - b.index;
    })
    .map(({ game }) => game);

export type DailyScheduleActionKind = "watch" | "sim";

export type DailyScheduleActionPlan = {
  kind: DailyScheduleActionKind;
  primary: boolean;
};

export const getDailyScheduleActionPlan = ({
  isToday,
  tradeDeadline,
  userTeamGame,
}: {
  isToday: boolean;
  tradeDeadline: boolean;
  userTeamGame: boolean;
}): DailyScheduleActionPlan[] | undefined => {
  if (!isToday || tradeDeadline) {
    return;
  }

  return [
    {
      kind: "watch",
      primary: userTeamGame,
    },
    {
      kind: "sim",
      primary: false,
    },
  ];
};

export const getSimToDayTargetGid = (games: DailyScheduleGame[]) => {
  if (games.length === 0) {
    return;
  }

  return Math.min(...games.map((game) => game.gid));
};
